import * as React from 'react'
import { styled } from 'next-yak'

import * as S from '../../styles'

export type EditButtonProps = {
  glyph: React.ReactNode
  onlyGlyph?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

function EditButtonComponent({ children, glyph, onlyGlyph, ...buttonProps }: EditButtonProps): React.ReactElement<any> {
  return (
    <S.button.EditButton $onlyGlyph={onlyGlyph} {...buttonProps}>
      {glyph}
      {!onlyGlyph && <>{children}</>}
    </S.button.EditButton>
  )
}

export const EditButton = styled(EditButtonComponent)``
